/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMediaQuery } from "@mui/material";
import { poisBountyAssets } from "assets/cdn";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import { useNavigate } from "react-router-dom";
import { onClosePopUp, selectPoisBountyV3State } from "redux/slices";
import { Button, Container, Description, Title } from "./styles";

interface PBV3ClubChangeProps {
	isNewClub: boolean;
}

export const PBV3ClubChange = ({ isNewClub }: PBV3ClubChangeProps) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const { clubName } = useAppSelector(selectPoisBountyV3State);
	const isPortrait = useMediaQuery(
		"(orientation: portrait) and (max-width: 899px)"
	);
	const scale = useCalculateScale(
		isPortrait ? 400 : 1050,
		isPortrait ? 600 : 400
	);

	const continueShopping = () => {
		navigate("/shop");
		onClose();
	};
	const onClose = async () => {
		dispatch(onClosePopUp());
	};

	return (
		<Container
			scale={scale}
			image={getImage(
				isPortrait
					? poisBountyAssets.v3.cycle.background
					: poisBountyAssets.v3.cycle.backgroundLandscape
			)}
		>
			<CloseIconButton onClose={onClose} />
			<div>
				<Title>
					{isNewClub && clubName ? `Welcome to ${clubName}!` : "Club Update"}
				</Title>
				{!isPortrait && (
					<Description>
						{isNewClub ? (
							<>
								You’re now contributing to your {clubName ? "new" : ""}
								<br /> Club’s Poi’s Bounty progress.
							</>
						) : (
							<>
								The club event is no longer available.
								<br /> You have been redirected to your Personal event.
							</>
						)}
					</Description>
				)}
			</div>
			<div>
				{isPortrait && (
					<Description>
						{isNewClub ? (
							<>
								You’re now contributing to
								<br /> your new Club’s Poi’s
								<br /> Bounty progress.
							</>
						) : (
							<>
								The club event is
								<br /> no longer available.
								<br /> You have been redirected
								<br /> to your Personal event.
							</>
						)}
					</Description>
				)}
				<div>
					<Button themeColor="secondary" onClick={continueShopping}>
						Continue Shopping
					</Button>
				</div>
			</div>
		</Container>
	);
};
